export default {
  id: 'FinanceTable',
  code: 'CN',
  text: {
    'Discount Price': '折扣金额',
    'Export Record': '导出记录',
    'To Excel': 'Excel格式',
    'To CSV': 'CSV格式'
  }
}



// WEBPACK FOOTER //
// ./src/containers/tables/FinanceTable/locale.js